import styled from "styled-components"

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`

export const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 20rem;

  /* Equal-width columns in both header and body. */
  > div > div,
  > div > div > div {
    flex: 1;
    min-width: 0;
  }
`

export const Name = styled.p`
  ${(p) => p.theme.bold};
  margin: 0;
`

export const Id = styled.p`
  font-size: 1rem;
  margin: 0;
`

export const IdCell = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  width: 100%;
`

export const IdText = styled.span`
  font-size: 1.1rem;
  color: ${(p) => p.theme.colors.greyDarker};
  font-family: monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  min-width: 0;
  flex: 1;
`

export const TriggerBadge = styled.span`
  background: ${(p) => p.theme.colors.turquoiseLighter};
  color: ${(p) => p.theme.colors.turquoiseDark};
  padding: 0.2rem 0.8rem;
  border-radius: 0.4rem;
  font-size: 1.1rem;
  ${(p) => p.theme.bold};
`

export const StatusBadge = styled.span<{ $published?: boolean }>`
  font-size: 1.1rem;
  padding: 0.3rem 0.8rem;
  border-radius: 0.3rem;
  white-space: nowrap;
  background: ${(p) =>
    p.$published ? p.theme.colors.turquoiseDark : p.theme.colors.greyLight};
  color: ${(p) =>
    p.$published ? p.theme.colors.white : p.theme.colors.greyDarker};
`

export const DraftIndicator = styled.span`
  display: inline-block;
  font-size: 1.1rem;
  padding: 0.3rem 0.8rem;
  border-radius: 0.3rem;
  white-space: nowrap;
  background: #fef3c7;
  color: #92400e;
  margin-left: 0.5rem;
`

export const ExecutionCount = styled.span`
  font-family: monospace;
  font-size: 1.1rem;
  color: ${(p) => p.theme.colors.greyDarker};
`

export const SuccessCount = styled.span`
  color: ${(p) => p.theme.colors.turquoiseDark};
`

export const FailedCount = styled.span`
  color: ${(p) => p.theme.colors.errorText};
`

export const EmptyList = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 3rem 0;

  svg {
    height: 2rem;
    margin-right: 2rem;
  }
`
